import React, { useContext } from "react"
import { Divider } from "antd"
import { useTranslation } from "react-i18next"
import ProductUnits from "./ProductUnits"
import ProductCategories from "./ProductCategories"
import CurrencyRate from "./CurrencyRate"
import MarkupPercent from "./MarkupPercent"
import DebtReminders from "./DebtReminders"   // tog'a 1295: qarz eslatmasi sozlamasi
import SubscriptionBatterySwitch from "./SubscriptionBatterySwitch"   // Boshliq (2026-09-05): batareyka yoqish/o'chirish
import DatabaseBackup from "./DatabaseBackup"
import AudioChange from "./AudioChange"
import Modes from "./Modes"
import hasPermission from "../../../../utils/hasPermission"
import { AuthContext } from "../../../../contexts/auth/AuthContext"

export default function SiteSettingsTab() {
  const { t } = useTranslation()
  const { authState } = useContext(AuthContext)
  // Boshliq (2026-09-05): hamkor tizimlari (magazin/kontragent) — batareyka tugmasi; SAV'da batareyka yo'q
  const isMainTenant = Number((authState.user as any)?.tenantId || 1) <= 1
  return (
    <>
      <Divider orientation="left">{t("modes")}</Divider>
      <Modes />
      {hasPermission(authState.user) ? (
        <>
          <Divider orientation="left">{t("productUnits")}</Divider>
          <ProductUnits />
          <Divider orientation="left">{t("categories")}</Divider>
          <ProductCategories />
          <Divider orientation="left">{t("currencyRate")}</Divider>
          <CurrencyRate />
          {/* Boshliq (2026-09-03, tog'a 952/961): ustama % — Ostatkada «Цена продажи» avtomat */}
          <Divider orientation="left">{t("markupPercent")}</Divider>
          <MarkupPercent />
          {/* tog'a 1295 (2026-09-05): qarz eslatmalari — interval/soat/kanallar (avval kodga qattiq yozilgan edi) */}
          {/* Boshliq (2026-09-05): eslatmalar hamkor tizimlari uchun ham — har tizim o'z sozlamasi, o'z admini (backend tenant bo'yicha) */}
          <Divider orientation="left">{t("debtReminders")}</Divider>
          <DebtReminders />
          {!isMainTenant && (
            <>
              <Divider orientation="left">{t("subBatteryLbl")}</Divider>
              <SubscriptionBatterySwitch />
            </>
          )}
          <Divider orientation="left">{t("changingOrderAudio")}</Divider>
          <AudioChange />
          {/* Egasi (2026-08-31): «База данных» bloki olib tashlandi — bu ish
              alohida «Резервные копии» bo'limida to'liq qilingan */}
        </>
      ) : (
        <></>
      )}
    </>
  )
}
